export default {
    userStickerList: (state, getters, rootState, rootGetters) => (userId) => {
        return state.stickerList[userId];
    },
    stickerList(state){
        return state.stickers;
    },
    stickerItems(state, getters, rootState, rootGetters) {
        return state.stickerItems;
    }
}